<mat-form-field appearance="outline" class="w-100">
  <!-- Spinner for search loading state -->
  <ngx-spinner
    [zIndex]="-1"
    name="spBusqueda"
    bdColor="rgba(255, 255, 255, 0.8)"
    size="small"
    color="var(--primary-color)"
    type="line-scale"
    [fullScreen]="false"
  ></ngx-spinner>

  <!-- Label for the input -->
  <mat-label>Expedientes</mat-label>

  <!-- Search input field -->
  <input
    matInput
    type="search"
    placeholder="Buscar por nombre o documento"
    [disabled]="disable"
    [formControl]="entityControl"
    [matAutocomplete]="auto"
    aria-label="Buscar expediente"
  />

  <!-- Search button (disabled while input is empty) -->
  <button
    mat-icon-button
    matSuffix
    [disabled]="!entityControl.value"
    matTooltip="Buscar expediente"
  >
    <mat-icon>search</mat-icon>
  </button>

  <!-- Autocomplete list for filtered expedientes -->
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option
      *ngFor="let expediente of filteredExpedientes | async; trackBy: trackByItems"
      [value]="expediente.descripcion"
      (click)="selectValue(expediente)"
      (onSelectionChange)="selectValue(expediente)"
    >
      <span matTooltip="{{ expediente.descripcion }}" matTooltipPosition="right">
        {{ expediente.descripcion | titlecase }}
      </span>
    </mat-option>
  </mat-autocomplete>

  <!-- Clear button to reset the selection -->
  <button
    mat-icon-button
    matSuffix
    matTooltip="Limpiar selección"
    *ngIf="entitySelect"
    (click)="selectValue(null)"
  >
    <mat-icon>clear</mat-icon>
  </button>
</mat-form-field>
